import { Component, Input } from '@angular/core';

@Component({
  selector: 'contract-detail-collaterals',
  templateUrl: './contract-detail-collaterals.component.html',
  styleUrls: ['./contract-detail-collaterals.component.scss'],
  standalone: false,
})
export class ContractDetailCollateralsComponent {
  public constructor() {}

  @Input() collaterals: app.models.ContractDetailCollateralModel[];
  @Input() props: app.models.DynamicPropsDictionary;
}
